var ownerServiceObj =
{
    getOwnerList() {
        return { data: [] };
    },
    getPersonOwner(ownerId) {
        return axios.get('api/owner/person/' + ownerId)
    },

    getCompanyOwner(ownerId) {
        return axios.get('api/owner/company/' + ownerId)
    },

    saveOwner(owner) {
        return axios.post('api/Owner', owner)
    },

    savePerson(person) {
        return axios.post('api/Owner/person', person)
    },

    saveCompany(company) {
        return axios.post('api/Owner/company', company)
    },

    deleteOwner(id) {
        return axios.delete('api/Owner/' + id)
    },

    getListByUniqueKey(query, type) {
        return axios.get('api/owner/getListByUniqueKey', { params: { query: query, type: type } })
    },

    getPersonLastAddress(personId) {
        return axios.get('api/owner/person/lastAddress/' + personId)
    },

    getCompanyLastAddress(companyId) {

        return axios.get('api/owner/company/lastAddress/' + companyId)
    },

    getVehicleListForOwner(id, type) {
        return axios.get('api/owner/getVehicleListForOwner', { params: { id: id, type: type } })
    }
}

export const ownerService = ownerServiceObj;
